import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import profileBusinessTravel from '~/modules/master/redux/actions/business-travel'

const useBusinessTravel = () => {
  const data = useSelector((state) => get(state, 'master.businessTravel'))

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(profileBusinessTravel, dispatch),
    [dispatch],
  )
  return {
    actions,
    data,
  }
}

export default useBusinessTravel
